import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const enumDetailsFormStyle: StyleRulesCallback = () => {
  return {
    root: {},
  };
};

export default enumDetailsFormStyle;
